export const FETCH_SUCCESS = "ROLES/FETCH_SUCCESS";
export const TABLE_UPDATE = "ROLES/TABLE_UPDATE";

const types = {
    DESTROY_FAILED: "ROLES/DESTROY_FAILED",
    DESTROY_REQUEST: "ROLES/DESTROY_REQUEST",
    DESTROY_SUCCESS: "ROLES/DESTROY_SUCCESS",

    FETCH_FAILED: "ROLES/FETCH_FAILED",
    FETCH_REQUEST: "ROLES/FETCH_REQUEST",
    FETCH_SUCCESS,

    FETCH_ALL_FAILED: "ROLES/FETCH_ALL_FAILED",
    FETCH_ALL_REQUEST: "ROLES/FETCH_ALL_REQUEST",
    FETCH_ALL_SUCCESS: "ROLES/FETCH_ALL_SUCCESS",

    GET_FAILED: "ROLES/GET_FAILED",
    GET_REQUEST: "ROLES/GET_REQUEST",
    GET_SUCCESS: "ROLES/GET_SUCCESS",

    STORE_FAILED: "ROLES/STORE_FAILED",
    STORE_REQUEST: "ROLES/STORE_REQUEST",
    STORE_SUCCESS: "ROLES/STORE_SUCCESS",

    UPDATE_FAILED: "ROLES/UPDATE_FAILED",
    UPDATE_REQUEST: "ROLES/UPDATE_REQUEST",
    UPDATE_SUCCESS: "ROLES/UPDATE_SUCCESS",

    TABLE_UPDATE,
};

export default types;
